// extracted by mini-css-extract-plugin
export default {"mainContainer":"Checkout_mainContainer__7pxns","backBtn":"Checkout_backBtn__6-LEn","btnText":"Checkout_btnText__N7r8g"};